import React from 'react'
import { FormContextProvider } from '../../../../context/formContext'
import CreateForm from './CreateForm'
import Toast from '../../../../components/Toast/Toast'
const FormWrapper = () => {
  return (
    <FormContextProvider>
      <CreateForm />
      <Toast />
    </FormContextProvider>
  )
}

export default FormWrapper
